import * as types from '@/store/organization/actionTypes';
// eslint-disable-next-line import/no-cycle
import {
  createOrUpdateOrganization,
  deleteOrganization,
  getAllOrganizations, setDefaultOrganization,
} from '@/services/repository';
import { CLEAR_ORGANIZATIONS, SET_ORGANIZATIONS } from '@/store/organization/mutationTypes';
import { LOAD_CLOUD_ACCOUNTS_FROM_CONFIGURATION, LOAD_DOMAINS_FROM_CONFIGURATION } from '@/store/project/actionTypes';
import { LOAD_DOMAINS } from '@/store/user/actionTypes';
import { SET_ORGANIZATION_FILTER } from '@/store/filters/actionTypes';

export default {
  async [types.ADD_OR_UPDATE_ORGANIZATION]({ dispatch, getters }, payload) {
    try {
      await createOrUpdateOrganization(payload);
      await dispatch(LOAD_DOMAINS);
      await dispatch(LOAD_DOMAINS_FROM_CONFIGURATION);
      await dispatch(LOAD_CLOUD_ACCOUNTS_FROM_CONFIGURATION);
      await dispatch(types.LOAD_ALL_ORGANIZATIONS);
      await dispatch(SET_ORGANIZATION_FILTER, [getters.companyData.name]);
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async [types.LOAD_ALL_ORGANIZATIONS]({ commit }) {
    try {
      const organizations = await getAllOrganizations();
      commit(SET_ORGANIZATIONS, organizations);
    } catch (e) {
      console.error(e);
      commit(CLEAR_ORGANIZATIONS);
      throw e;
    }
  },
  async [types.DELETE_ORGANIZATION]({ dispatch }, id) {
    try {
      await deleteOrganization(id);
      await dispatch(types.LOAD_ALL_ORGANIZATIONS);
    } catch (e) {
      // Propagate the server's error message (e.g. TPRM deletion blocked) to the UI
      const serverMessage = e?.response?.data?.message;
      throw new Error(serverMessage || e.message);
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async [types.SET_DEFAULT_DOMAIN]({}, payload) {
    try {
      await setDefaultOrganization(payload);
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};
